export class Result {
    constructor(public isValid: boolean, public errorTitleKey?: string, public errorKey?: string, public isGlobalError?: boolean) {
    }
}
